'use strict';

let staticFiles = {"email":{"en_US":"static/email/email_en_US.html","default":"static/email/email_en.html","en":"static/email/email_en.html"},"help":{"de_DE":"static/help/help_de_DE.html","en_US":"static/help/help_en_US.html","default":"static/help/help_en.html","en":"static/help/help_en.html"},"homepage":{"en_US":"static/homepage/homepage_en_US.html","default":"static/homepage/homepage_en.html","en":"static/homepage/homepage_en.html"}};

export function getStaticOtbHtml() {
    return staticFiles;
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/appConfig/staticFiles.ts